/**
 * Video intro cutscene.
 * Plays public/intro.mp4 fullscreen over the 3D scene.
 * A "tap to begin" gate ensures the video plays with audio despite browser
 * autoplay restrictions. SKIP button or video end → calls onDone().
 */
export class Intro {
  private el: HTMLDivElement;
  private video: HTMLVideoElement;
  private skipBtn: HTMLButtonElement;
  private tapGate: HTMLDivElement;
  private onDone: () => void = () => {};

  constructor(parent: HTMLElement) {
    this.el = document.createElement("div");
    this.el.className = "intro hidden";

    this.video = document.createElement("video");
    this.video.src = "/intro.mp4";
    this.video.playsInline = true;
    this.video.muted = false;
    this.video.preload = "auto";
    this.video.style.cssText =
      "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;";

    this.skipBtn = document.createElement("button");
    this.skipBtn.className = "intro-skip";
    this.skipBtn.textContent = "SKIP";
    this.skipBtn.style.display = "none";
    this.skipBtn.addEventListener("click", () => this.finish());

    this.tapGate = document.createElement("div");
    this.tapGate.className = "intro-tap-gate";
    this.tapGate.innerHTML = `<span class="intro-tap-label">TAP TO BEGIN</span>`;
    this.tapGate.addEventListener("click", () => this.startVideo());

    this.video.addEventListener("ended", () => this.finish());

    this.el.appendChild(this.video);
    this.el.appendChild(this.tapGate);
    this.el.appendChild(this.skipBtn);
    parent.appendChild(this.el);
  }

  private startVideo(): void {
    this.tapGate.style.display = "none";
    this.skipBtn.style.display = "";
    this.video.currentTime = 0;
    this.video.play().catch(() => this.finish());
  }

  show(onDone: () => void): void {
    this.onDone = onDone;
    this.el.classList.remove("hidden");
    this.el.style.opacity = "1";
    this.tapGate.style.display = "";
    this.skipBtn.style.display = "none";
    this.video.currentTime = 0;
    this.video.pause();
  }

  private finish(): void {
    this.video.pause();
    this.el.style.transition = "opacity 0.5s";
    this.el.style.opacity = "0";
    window.setTimeout(() => {
      this.el.classList.add("hidden");
      this.onDone();
    }, 520);
  }

  destroy(): void {
    this.video.pause();
    this.el.remove();
  }
}
